import React from 'react';

import cardStyles from './styles/TutorStatsOverview.module.css';
import pageStyles from './styles/TutorLandingPage.module.css';

export default function StatsOverviewCard({
  enrolledLearners,
  hoursTaught,
  monthlyEarnings,
  courseViews,
  onOpenSummary,
}) {
  const formattedMonthlyEarnings = monthlyEarnings
    ? `$${monthlyEarnings.toLocaleString()}`
    : '$0';

  return (
    <section className={cardStyles.statsCard}>
      <p className={cardStyles.statsLabel}>Stats overview</p>

      <div className={pageStyles.tutorStatRow}>
        <span className={pageStyles.tutorStatLabel}>Learners enrolled</span>
        <span className={pageStyles.tutorStatValue}>
          {enrolledLearners ? enrolledLearners.toLocaleString() : 0}
        </span>
      </div>

      <div className={pageStyles.tutorStatRow}>
        <span className={pageStyles.tutorStatLabel}>Hours taught</span>
        <span className={pageStyles.tutorStatValue}>
          {hoursTaught ? hoursTaught.toLocaleString() : 0} hrs
        </span>
      </div>

      <div className={pageStyles.tutorStatRow}>
        <span className={pageStyles.tutorStatLabel}>This month&apos;s earnings</span>
        <span className={pageStyles.tutorStatValue}>
          {formattedMonthlyEarnings}
        </span>
      </div>

      <div className={cardStyles.earningsDivider} />

      {courseViews?.length > 0 && (
        <>
          <div className={cardStyles.viewsHeader}>
            <span className={cardStyles.viewsHeaderText}>View count</span>
          </div>

          <div className={cardStyles.courseViewsList}>
            {courseViews.map((course) => (
              <div key={course.id} className={pageStyles.tutorStatRow}>
                <span className={pageStyles.tutorStatLabel}>{course.name}</span>
                <span className={pageStyles.tutorStatValue}>
                  {course.viewCount ? course.viewCount.toLocaleString() : 0}
                </span>
              </div>
            ))}
          </div>
        </>
      )}

      <p className={cardStyles.statsHint}>
        Every view is a sign families are discovering your classes. Keep going! Your own views are not counted.
      </p>

      <button
        type="button"
        className={pageStyles.tutorSmallButtonGhost}
        onClick={onOpenSummary}
      >
        View full details
      </button>
    </section>
  );
}